import LayoutComponent from "src/components/user/layout-component";
import ResearchResultsContainer from "src/containers/user/research-results-container/research-results-container";
import SearchBarComponent from "src/containers/user/search-bar-container/search-bar-container";

function ResearchResultsPage() {
  
  return (
    <LayoutComponent showLogo={true}>
      <div className="flex flex-col bg-zinc-50">
        <div className="w-auto h-56 bg-navey-50 mobile:h-44"></div>
        {/* check this line after rebase the search bar component */}
        <div className="flex justify-center -mt-[60px] mobile:-mt-[110px]">
          <SearchBarComponent />
        </div>
        {/* Replace this with your container */}
        <ResearchResultsContainer />
        {/* Replace this with your container */}
      </div>
    </LayoutComponent>
  );
}

export default ResearchResultsPage;
